import { Input, Select, Table, Typography } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  .ant-table-content {
    margin-top: 16px;
  }

  .ant-table-container {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-shadow: inset 1px 0px 0px #e2e7ee, inset -1px 0px 0px #e2e7ee,
      inset 0px 1px 0px #e2e7ee, inset 0px -1px 0px #e2e7ee;
  }

  .ant-table-thead .ant-table-cell {
    padding: 9px 12px;
    font-size: 14px;
    font-weight: 600;
    background-color: #f7f9fe;
    color: #4a5368;
    box-shadow: inset 1px 0px 0px #e2e7ee, inset -1px 0px 0px #e2e7ee,
      inset 0px 1px 0px #e2e7ee;
  }

  && .ant-table-cell::before {
    background-color: #e2e7ee !important;
  }

  && .ant-table-cell {
    border-bottom: 1px solid #e2e7ee;
    padding: 8px 12px;
  }

  .ant-table-footer {
    padding: 0px;
    font-size: 14px;
    font-weight: 600;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #ffffff;
    color: #4a5368;
    box-shadow: inset 1px 0px 0px #e2e7ee, inset -1px 0px 0px #e2e7ee,
      inset 0px -1px 0px #e2e7ee;

    &.ant-btn {
      font-size: 14px;
    }
  }

  .ant-table-body::-webkit-scrollbar {
    width: 0;
  }
`;

export const StyledEmailWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  .ant-row {
    width: 100%;
    justify-content: space-between;
  }
`;

export const StyledTitle = styled(Typography.Title)`
  &.ant-typography {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin: 0;
    color: #4a5368;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const CreateWrapper = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  padding: 8px 12px;

  .ant-form-item {
    margin: 0;
  }
`;

export const StyledInput = styled(Input)`
  border-radius: 8px;
  border-color: #bdc5db;
  color: #4a5368;
`;

export const StyledSelect = styled(Select)`
  font-weight: 400;
  font-size: 12px;

  &.arrow-icon {
    color: #8e9cbd;
  }

  &.ant-select-open .arrow-icon {
    transform: rotate(180deg);
  }

  .ant-select-selection-overflow {
    gap: 4px;
  }

  .ant-select-selection-item {
    padding: 0px;
    margin: 0;
    height: 16px;
    display: flex;
    align-items: center;
    background-color: #6a7695;
    color: #ffffff;
    padding: 0px 4px 0px 8px;
  }
  .ant-select-selection-item-remove {
    padding-top: 3px;
    color: #ffffff;
  }

  .ant-select {
    margin-right: 12px;
    border-radius: 8px;
    border-color: #bdc5db;
    color: #4a5368;
  }

  .ant-select-selector {
    border: 1px solid #bdc5db !important;
    border-radius: 8px !important;
  }

  .ant-select-multiple {
    font-weight: 400;
    font-size: 12px;
  }
`;
